import { sendEmailAgreement } from "../../../../actions/Email";
import { useMutation } from "react-query";
//Fetching Carrier Contact

const useSendEmail = () => {
  return useMutation(sendEmailAgreement);
};
export default useSendEmail;
